import type { FilteredProduct } from '@/api';
import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { createReissuedMedication } from '../utils/createReissuedMedication';
import { setRevalidatedPad } from '../utils/setRevalidatedPad';

export const addReissuedMedicationToPrescriptionPad: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (availableMedications: FilteredProduct[], reissuedMedication: MedicationPadItemType) => void
> = (set, get) => (availableMedications, reissuedMedication) => {
  const { prescriptionPad, prescriptionHistory, prescriptionPadRules } = get().prescriptionAssistant;
  const existingMedicationPadItems = prescriptionPad.medicationPadItems.filter((item) => !!item?.medicationPadItem);
  const previouslyPrescribedItem = prescriptionHistory.previousItems.find(
    (item) => item.id === reissuedMedication.medicationPadItem?.productId,
  );

  const newReissuedMedication = createReissuedMedication(
    availableMedications,
    reissuedMedication,
    previouslyPrescribedItem,
    prescriptionPadRules,
  );

  if (!newReissuedMedication) {
    return;
  }

  // The new item is validated with the pad it joins, and changes its formulation's limit in force, and with it the
  // phrase written into every sibling's dosage, so the siblings are re-validated too
  setRevalidatedPad(
    set,
    { ...prescriptionPad, medicationPadItems: [newReissuedMedication, ...existingMedicationPadItems] },
    prescriptionPadRules,
    'prescriptionPad/addReissuedMedication',
  );
};
